import { Link } from "react-router-dom";

import { useCanSeeFrontEndAdmin } from "shared/hooks/usePermissions";

const DotAdminLink = ({
  caseId,
  specimenId,
  slideId,
}: {
  caseId: number;
  specimenId?: number;
  slideId?: number;
}) => {
  const canSeeAdmin = useCanSeeFrontEndAdmin();
  let baseUrl = `${process.env.REACT_APP_BACKEND_PROTOCOL}://${process.env.REACT_APP_VIEWER_DOMAIN}/admin/cases/${caseId}`;

  if (specimenId) baseUrl += `/specimens/${specimenId}`;
  if (slideId) baseUrl += `/slides/${slideId}`;

  return canSeeAdmin ? (
    <Link to={baseUrl} className="Case__header__edit" target="_blank">
      Edit {specimenId ? "Specimen" : slideId ? "Slide" : "Case"} in dot. Admin
      ↗
    </Link>
  ) : null;
};

export default DotAdminLink;
